import { Directive, TemplateRef } from '@angular/core';

// A7 Switch Panel Junior Template Directive
@Directive({
    selector: '[a7Panel]',
    standalone: false
})
export class A7SpjTemplateDirective {
  constructor(public template: TemplateRef<{ $implicit: any }>) {}
}
